module.exports = __webpack_public_path__ + "img/top.84d7c3b8.png";